export const MODA_ARTICOLI_COSTI_PERMISSION = "read:contabile";

// Filtri del listino WEB attivo (backend: MODA_ARTICOLI_PREZZI_FILTERS).
// I riservati rivelano il costo acquisto medio: il backend li rifiuta senza
// read:contabile, qui restano visibili ma disabilitati.
export const PREZZI_FILTER_FIELDS = [
  { label: "Prezzo cartellino", min: "prezzoCartellinoMin", max: "prezzoCartellinoMax", unit: "€" },
  { label: "Prezzo scontato", min: "prezzoScontatoMin", max: "prezzoScontatoMax", unit: "€" },
  { label: "Percentuale sconto", min: "scontoPercentualeMin", max: "scontoPercentualeMax", unit: "%" },
  { label: "Costo acquisto medio", min: "costoAcquistoMedioMin", max: "costoAcquistoMedioMax", unit: "€", riservato: true },
  { label: "Margine da cartellino", min: "margineCartellinoMin", max: "margineCartellinoMax", unit: "%", riservato: true },
  { label: "Margine da scontato", min: "margineScontatoMin", max: "margineScontatoMax", unit: "%", riservato: true },
];

export const PREZZI_FILTER_LABELS = PREZZI_FILTER_FIELDS.reduce(
  (labels, field) => ({
    ...labels,
    [field.min]: `${field.label} >=`,
    [field.max]: `${field.label} <=`,
  }),
  {},
);

export const PREZZI_RISERVATI_FILTER_KEYS = PREZZI_FILTER_FIELDS.filter(
  (field) => field.riservato,
).flatMap((field) => [field.min, field.max]);

// Un valore riservato arrivato da filtri salvati non deve partire nella
// richiesta di chi non ha il permesso: il backend la rifiuterebbe per intero.
export const withoutPrezziRiservati = (filters, canReadCosti) =>
  canReadCosti
    ? filters
    : Object.fromEntries(
        Object.entries(filters).filter(
          ([key]) => !PREZZI_RISERVATI_FILTER_KEYS.includes(key),
        ),
      );
